<template>
  <section class="testimonials">
    <bacon title="Testimonials"></bacon>
    <section class="slider">
      <transition-group name="slide" mode="out-in">
        <div class="slide" v-for="(item, i) in testimonials" v-show="i == selected" v-bind:key="item.name">
          <h3 class="two-line-heading">{{item.name}}
              <span>{{item.title}}</span>
          </h3>
          <p class="description">{{item.description}}</p>
        </div>
      </transition-group>
      <div class="controls">
        <span v-if="showDots" v-for="(item, i) in testimonials"
            :class="{active: i == selected}" class="dot" @click="select(i)">
        </span>
      </div>
    </section>
  </section>
</template>

<script>
  import Bacon from './bacon.vue'

  export default {
    components: {Bacon},

    props: {
      id: String,
      name: String,
      showDots: {
        type:Boolean,
        default: true
      },
      arrowPath: {
        type: String,
        default: ''
      }
    },

    data () {
      return {
        selected: 0,
        testimonials: [
          {
            name: 'Joseph Amabile',
            title: 'Bootleggers Coffee',
            description: 'My experience in working with Tai was one of professionalism. ' +
            'Attention was made to detail and prompt timing to any requests of changes i needed ' +
            'was given. I would recommend using TAI Design for all your design needs.'
          },
          {
            name: 'Alexis Prousis',
            title: 'Marketing Professional',
            description: 'Nikoleta was a pleasure to work with. She is not only extremely talent,' +
            ' but a true professional. Her design work is exceptional. I was able to send her copy' +
            ' and a few directions - and she brought my marketing collateral to life.'
          },
          {
            name: 'John Yi',
            title: 'Co-Founder at NextME',
            description: 'Nikoleta\'s ability to quickly comprehend convoluted concepts and convey ' +
            'visually through design is impressive. She needs very little hand holding and would' +
            ' be a great asset to any team looking for a talented designer.'
          }
        ]
      }
    },

    mounted: function () {
      setInterval(() => {
        this.selected = (this.selected + 1) % this.testimonials.length;
      }, 7000);
    },

    methods: {
      select: function (index) {
        this.selected = index;
      }
    }

  }
</script>

<style lang="scss">
  // TODO: move this to the index
  @import "../../css/testimonials.scss";
</style>


// WEBPACK FOOTER //
// testimonials.vue?22142409